import _ from 'lodash'

import { setRequest } from '../../../misc/api'
import type { Constant, MedicalUnit, RemoteListNamedEntity } from './types'
import { RemoteListsState } from './types'

export const mutations = {
  fetchMedicalUnitsStart(state: RemoteListsState) {
    state.medicalUnitsRequest = { fetching: true, error: null, ok: false }
  },
  fetchMedicalUnitsSuccess(state: RemoteListsState, umlist: MedicalUnit[]) {
    state.medicalUnitsRequest.fetching = false
    state.medicalUnitsRequest.ok = true
    state.medicalUnits = umlist
    state.divisions = _.uniqBy(_.map(umlist, (um: MedicalUnit) => um.facilityDivision), 'id')
    state.facilities = _.uniqBy(_.map(umlist, (um: MedicalUnit) => um.facilityDivision.facility), 'id')
  },
  fetchMedicalUnitsError(state: RemoteListsState, res: { message: string }) {
    state.medicalUnitsRequest.fetching = false
    state.medicalUnitsRequest.error = res.message
    state.medicalUnits = []
  },
  fetchConstantsStart(state: RemoteListsState) {
    state.constantsRequest = { fetching: true, error: null, ok: false }
  },
  fetchConstantsSuccess(state: RemoteListsState, constantList: Constant[]) {
    state.constantsRequest.fetching = false
    state.constantsRequest.ok = true
    state.constants = constantList
  },
  fetchConstantsError(state: RemoteListsState, res: { message: string }) {
    state.constantsRequest.fetching = false
    state.constantsRequest.error = res.message
    state.constants = []
  },
  fetchDataPresenceStart(state: RemoteListsState) {
    state.dataPresenceRequest = { fetching: true, error: null, ok: false }
  },
  fetchDataPresenceSuccess(state: RemoteListsState, presences) {
    state.dataPresenceRequest.fetching = false
    state.dataPresenceRequest.ok = true
    state.hasDrugs = presences.drugs
    state.hasHealthConstantss = presences.healthConstants
    state.hasBiologyResults = presences.labResults || presences.categoricalLabResults
  },
  fetchDataPresenceError(state: RemoteListsState, res: { message: string }) {
    state.dataPresenceRequest.fetching = false
    state.dataPresenceRequest.error = res.message
  },
  getCompletionItemsStart(state: RemoteListsState) {
    state.completionRequest = { fetching: true, error: null, ok: false }
  },
  getCompletionItemsSuccess(state: RemoteListsState, items: []) {
    state.completionRequest.fetching = false
    state.completionRequest.ok = true
    state.completionItems = items
  },
  getCompletionItemsError(state: RemoteListsState, res: { message: string }) {
    state.completionRequest.fetching = false
    state.completionRequest.error = res.message
    state.completionItems = []
  },
  clearCompletionItems(state: RemoteListsState) {
    state.completionItems = []
  },
  getBiologyValuesStart(state: RemoteListsState) {
    state.biologyValuesRequest = { fetching: true, error: null, ok: false }
  },
  getBiologyValuesSuccess(state: RemoteListsState, items: []) {
    state.biologyValuesRequest.fetching = false
    state.biologyValuesRequest.ok = true
    state.biologyValues = items
  },
  getBiologyValuesError(state: RemoteListsState, res: { message: string }) {
    state.completionRequest.fetching = false
    state.completionRequest.error = res.message
  },
  clearBiologyValues(state: RemoteListsState) {
    state.biologyValues = []
  },
  setNamedEntities(state: RemoteListsState, namedEntities: RemoteListNamedEntity[]) {
    state.namedEntities = namedEntities
  },
  clearNamedEntities(state: RemoteListsState) {
    state.namedEntities = []
  },
  setRequest,
}
